<template>
  <PageSection :title="t('profile.infoTitle')">
    <AccordionItem
      :text="t('profile.contactUs')"
      @click="() => handleOpen('contact')"
    />
    <AccordionItem :text="t('profile.FAQ')" @click="() => handleOpen('faq')" />
    <AccordionItem
      :text="t('profile.legal')"
      @click="() => handleOpen('legal')"
    />
    <AccordionItem
      :text="t('documents.claimTitle')"
      @click="() => handleOpen('neat')"
    />
    <!-- Logout option, only visible on mobile -->
    <AccordionItem
      v-if="isMobile"
      class="d-md-none"
      :text="t('navbar.logout')"
      @click="logout"
      :displayIcon="false"
    />
  </PageSection>
</template>

<script lang="ts" setup>
  // Types
  import { Locale } from '@/types'

  // Config
  import { links, Links } from '@/config/links'

  // Components
  import PageSection from '../UI/PageSection.vue'
  import AccordionItem from './AccordionItem.vue'

  // Store
  import { useStore } from '@/store'
  const store = useStore()

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Composables
  import useScreenSize from '@/composables/useScreenSize'

  // Services
  import YoonlyService from '@/services/YoonlyService'

  // Methods
  const handleOpen = (key: keyof Links, target = '_blank'): void => {
    const link: string = getLink(key)
    window.open(link, target)
  }

  const logout = () => {
    store.dispatch('auth/logout')
  }

  // Computed
  const { isMobile } = useScreenSize()
  const isYoonly = new YoonlyService().isYoonly

  const getLink = (key: keyof Links): string => {
    const locale = store.getters.getLocale as Exclude<Locale, 'en-US'>

    const localeLinks: Links = links[isYoonly ? "yoonly" : locale]
    if (!localeLinks) throw new Error('invalid locale in getLink')
    return localeLinks[key] || ''
  }
</script>
